import ImportRepository from "@domain/repositories/ImportRepository";
import showToast from "@helpers/showToast";
import { HttpClient } from "@data/api/HttpClient";
import { Client } from "@domain/models/Client";
import { DbClient } from "@domain/models/DbClient";

export class HttpImportRepository implements ImportRepository {
  private readonly baseUrl = `${process.env.REACT_APP_API_URL}/import`;

  constructor(private readonly httpClient: HttpClient) {}

  async getImportHistory() {
    return this.httpClient
      .request({
        method: "GET",
        url: `${this.baseUrl}/history`,
      })
      .then((response) => {
        return response.data;
      });
  }

  async getImportHistoryClients(importHistoryId: string) {
    return this.httpClient
      .request({
        method: "GET",
        url: `${this.baseUrl}/history/${importHistoryId}/clients`,
      })
      .then((response) => {
        return response.data;
      });
  }

  async validateImport(clients: Client[]) {
    return this.httpClient
      .request({
        method: "POST",
        url: `${this.baseUrl}/clients/validate`,
        body: JSON.stringify({ clients }),
      })
      .then((response) => {
        showToast(response.message, "warn");
        return response.data;
      });
  }

  async importClients(selectedClients: Client[], notSelectedClients: Client[]) {
    return this.httpClient
      .request({
        method: "POST",
        url: `${this.baseUrl}/clients`,
        body: JSON.stringify({ selectedClients, notSelectedClients }),
      })
      .then((response) => {
        if (response.message.includes("sucesso")) {
          showToast(response.message, "success");
        } else {
          showToast(response.message, "warn");
        }

        return response.data;
      });
  }

  async importDbClients(type: "auxBrasil" | "indeferidosDb" | "deferidos", dbClients: DbClient[]) {
    return this.httpClient
      .request({
        method: "POST",
        url: `${this.baseUrl}/clients/db`,
        body: JSON.stringify({ type, dbClients }),
      })
      .then((response) => {
        if (response.message.includes("sucesso")) {
          showToast(response.message, "success");
        } else {
          showToast(response.message, "warn");
        }

        return response.data;
      });
  }

  async undoImportClients(importHistoryId: string) {
    return this.httpClient
      .request({
        method: "POST",
        url: `${this.baseUrl}/history/${importHistoryId}/undo`,
      })
      .then((response) => {
        if (response.message.includes("sucesso")) {
          showToast(response.message, "success");
        } else {
          showToast(response.message, "warn");
        }

        return response.data;
      });
  }
}
